export const DynamicValueType = {
  BOOL: 'bool',
  CURRENCY: 'currency',
  DATE: 'date',
  DECIMAL: 'decimal',
  DOUBLE: 'double',
  INT: 'int',
  LOAN_ORIGINATOR_SIGN: 'loan-originator-sign',
  HAND_WRITING_SIGN: 'hand-writing-signature',
  LONG: 'long',
  PERCENT: 'percent',
  RATE: 'rate',
  STRING: 'string',
  TODAY_X_DAYS: 'today-x-days',
  DATE_X_BUSINESS_DAYS: 'date-x-business-days',
};

export const SignatureDynamicValueTypes = [
  DynamicValueType.LOAN_ORIGINATOR_SIGN,
  DynamicValueType.HAND_WRITING_SIGN,
];
